import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { LiveMatchViewDefault } from './LiveMatchViewDefault';
import { LiveMatchViewTouch } from './LiveMatchViewTouch';
import { LiveMatchViewConsole } from './LiveMatchViewConsole';
import { LiveMatchViewBroadcast } from './LiveMatchViewBroadcast';
import { LiveMatchViewBroadcastMin } from './LiveMatchViewBroadcastMin';

export const LiveMatchViewRouter = ({ matchId }) => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') || localStorage.getItem('operatorMode') || 'default';

  switch (mode) {
    case 'touch':
      return <LiveMatchViewTouch matchId={matchId} />;
    case 'console':
      return <LiveMatchViewConsole matchId={matchId} />;
    case 'broadcast':
      return <LiveMatchViewBroadcast matchId={matchId} />;
    case 'broadcast-min':
      return <LiveMatchViewBroadcastMin matchId={matchId} />;
    default:
      return <LiveMatchViewDefault matchId={matchId} />;
  }
};
